import React from 'react';
import NavButton from '../../../common/nav-button/NavButton';
import libraryWhite from '../../../../assets/icons/libraly_white.png';
import library from '../../../../assets/icons/libraly.png';
import searchbooksWhite from '../../../../assets/icons/searchbooks-white.png';
import searchbooks from '../../../../assets/icons/searchbooks.png';
import { useTranslation } from 'react-i18next';

function  NavigationPanel({toggle, isAuth, isOpen}) {
    const {t} = useTranslation();
    return (
        <>
        {
            isOpen ? (
                <>
                    <NavButton
                        to="/library"
                        onClick={toggle}
                        className={`mr-2 btn-secondary flex flex-row`}
                    >
                        <img src={library} alt="Home" className="mr-2 w-4 h-4"/>{
                        t('general.header.library')}
                    </NavButton>

                    <NavButton
                        to="/search"
                        onClick={toggle}
                        className={`mr-2 btn-secondary flex flex-row`}
                    >
                        <img src={searchbooks} alt="Home" className="mr-2"/>
                        {t('general.header.search')}
                    </NavButton>
                </>
            ) : (
                <>
                    <NavButton
                        to="/library"
                        onClick={toggle}
                        className={`mr-2 btn-secondary-white ml-7 flex flex-row`}
                    >
                        <img src={libraryWhite} alt="Home" className="mr-2"/>
                        {t('general.header.library')}
                    </NavButton>

                    <NavButton
                        to="/search"
                        onClick={toggle}
                        className={`mr-2 btn-secondary-white flex flex-row`}
                    >
                        <img src={searchbooksWhite} alt="Home" className="mr-2"/>
                        {t('general.header.search')}
                    </NavButton>
                </>
            )
        }
        </>
    );
}

export default NavigationPanel;
